import Vue from 'vue';
import Modal from '@/components/Modal.vue';
import CallScheduleForm from '@/products-and-services/CallScheduleForm.vue';
import ThemeMixin from '@/mixins/ThemeMixin';

export default Vue.extend({
    name: 'TavernModalWrapper',
    components: {
        CallScheduleForm,
        Modal
    },
    mixins: [
        ThemeMixin
    ],
    data() {
        return {
            showTavernModal: true,
            showTavernConfirmationModal: false,
            showSuccess: false,
            emailForScheduledCall: ''
        };
    },
    methods: {
        showTavernPhoneNumberModal() {
            this.showTavernModal = true;
        },
        async scheduleCallback() {
            this.showTavernModal = false;
            this.showTavernConfirmationModal = true;
        },
        hideConfirmTavern() {
            this.$emit('close');
            if (this.showSuccess) {
                this.$store.commit('clearShoppingCart');
            }
        },
        callScheduled(email: string) {
            this.emailForScheduledCall = email;
            this.showTavernConfirmationModal = false;
            this.showSuccess = true;
        }
    }
});
